<div class="text-align-left" (click)="showPopout = !showPopout">
	<p class="text-16 title">{{ text }}</p>
	<p class="text-12 subtitle">{{ subText }}</p>
</div>
<div class="pop-out {{ popoutPosition }}" [hidden]="!showPopout"><ng-content></ng-content></div>
